<section class="rs-es-first-section">
  <mprd-back-link></mprd-back-link>
  <div class="row">
    <div class="columns small-12">
      <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
        {{ "sim.physical-sim.title" | translate }}
      </h1>
      <p class="rs-subtit rs-txt-c2">
        {{ "sim.physical-sim.subtitle" | translate }}
      </p>
      <div class="rs-panel-big rs-bg-c2 clearfix">
        <div class="rs-flex-row">
          <div
            *ngFor="let i of ['shop', 'contact']"
            class="rs-flex-columns small-12 medium-6"
          >
            <div class="rs-panel-flex">
              <div
                class="rs-panel-flex-cell rs-bg-grey2 rs-flex rs-flex-dir-col"
              >
                <div class="rs-flex-grow">
                  <h2 class="rs-tit5">
                    {{ "sim.physical-sim." + i + "-title" | translate }}
                  </h2>
                  <p>
                    {{ "sim.physical-sim." + i + "-description" | translate }}
                  </p>
                </div>
                <div>
                  <a
                    [href]="'sim.physical-sim.' + i + '-url' | translate"
                    class="rs-btn rs-btn-third"
                  >
                    {{ "sim.physical-sim." + i + "-button" | translate }}
                    <i
                      class="rs-icon-btn-third rs-margin-left1"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rs-le2"></div>
    </div>
  </div>
</section>
